import { combineReducers } from 'redux';

import { formData } from './formData';
import { account } from './account';
import { accounts } from './accounts';

export const reducer = combineReducers({
  formData,
  account,
  accounts,
});
